import request from '@/config/axios'

export interface FirmFeaturesVO {
  firmErpEnabled?: boolean
  firmModules?: Record<string, boolean>
}

export const FirmConfigApi = {
  // 非律师租户常无此接口；静默失败，避免独立窗刷「操作失败」并污染冒烟
  features: () =>
    request.get<FirmFeaturesVO>({
      url: '/lawyer/firm/config/features',
      headers: { ignoreError: true }
    })
}
